var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"1650px"}},[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"label":"账户管理"}},[_c('AccountManage',{ref:"AccountManage"})],1),_c('TabPane',{attrs:{"label":"落地页管理"}},[_c('AdvPageManage',{ref:"AdvPageManage"})],1),_c('TabPane',{attrs:{"label":"媒体代码管理"}},[_c('SrcManage',{ref:"SrcManage"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }